<template>
  <div class="FormArticleJoint">
    <div class="views">
      <Wrap>
        <TabsHead
          :indexActive.sync="tabIndexActive"
          :labels="tabsLabels" />
      </Wrap>
    </div>
    <Wrap class="lg">
      <FormValidation @submit="save">
        <FormArticle
          v-if="tabActive.view === viewWrite"
          :article="article"
          @save="save"
          @update:article="$up('article', $event)" />
        <FormArticleExport
          v-else-if="tabActive.view === viewExport"
          :article="article"
          @update:article="$up('article', $event)" />
        <div class="stickyWrap">
          <Row>
            <Column :lg="3">
              <Field
                :isSwitch="true"
                :label="$t('autoSave')"
                type="checkbox"
                :value.sync="doAutoSave" />
            </Column>
            <Column :lg="9">
              <Btn class="info" :isLoading="isSavingArticle" type="submit">
                {{ $t('submit') }}
              </Btn>
            </Column>
          </Row>
        </div>
      </FormValidation>
    </Wrap>
  </div>
</template>

<script>
import FormArticle from '@forms/FormArticle'
import FormArticleExport from '@forms/FormArticleExport'
import TabsHead from '@components/TabsHead'
import { getters } from '@utils'
import { mergeLabelArrays } from '@utils/collections'
import { pluck } from 'rambda'

export default {
  components: {
    FormArticle,
    FormArticleExport,
    TabsHead,
  },
  props: {
    article: Object,
  },
  data() {
    const viewWrite = 'write'
    const viewExport = 'export'

    const tabs = mergeLabelArrays([
      { view: viewWrite },
      { view: viewExport },
    ], this.$t('tabs'))

    return {
      viewWrite,
      viewExport,

      tabIndexActive: 0,
      tabs,

      doAutoSave: true,
      saveTimeout: null,
    }
  },
  computed: {
    tabActive() {
      return this.tabs[this.tabIndexActive]
    },
    tabsLabels() {
      return pluck('label', this.tabs)
    },
    ...getters('isSavingArticle'),
  },
  methods: {
    save() {
      clearTimeout(this.saveTimeout)
      this.$emit('save')
    },
  },
  watch: {
    article: {
      deep: true,
      handler() {
        if (!this.doAutoSave) return
        // TODO: use utils/async debounce
        clearTimeout(this.saveTimeout)
        this.saveTimeout = setTimeout(() => {
          this.save()
        }, 3000)
      },
    },
  },
  beforeDestroy() {
    clearTimeout(this.saveTimeout)
  },
}
</script>

<style lang="scss">
.FormArticleJoint {
  .stickyWrap {
    background: transparent;
    bottom: 1rem;
    position: sticky;
    z-index: 2;

    &::after {
      background-image: linear-gradient(to bottom, transparent, $white 50%);
      bottom: -1rem;
      content: ' ';
      display: block;
      height: 10rem;
      pointer-events: none;
      position: absolute;
      width: 100%;
    }

    .Btn {
      z-index: 2;
      @include md {
        border-radius: 0;
        margin-top: 1rem;
      }
    }

    .Field-cont {
      margin: 1rem 1rem 0.5rem 0;
      position: relative;
      z-index: 2;
    }
  }

  .views {
    background: $white-bis;
    border-bottom: 1px solid $border-color;
    margin-bottom: $grid-unit;
    text-align: center;

    .TabsHead {
      border: 0;
      margin: 0;
    }
  }
}
</style>

<i18n>
{
  "en": {
    "articleTitle": "Best laptop for {0}",
    "tabs": [
      "Write",
      "Export"
    ],
    "submit": "Save",
    "autoSave": "Auto-save"
  }
}
</i18n>
